import i18next from 'i18next';

const fmt = new Intl.NumberFormat('en-US');

const VotingSummary = ({ voting }) => {
  if (!voting) {
    return (
      <p className="voting-summary__empty">{i18next.t('投票数据暂缺')}</p>
    );
  }

  const cast = voting.ballotsIssued - voting.ballotsNotReturned;
  const turnoutDisplay =
    voting.turnout === null ? '—' : `${voting.turnout.toFixed(2)}%`;

  const cells = [
    { label: i18next.t('选民登记总数'), value: fmt.format(voting.registered) },
    { label: i18next.t('投票人数'), value: fmt.format(cast) },
    { label: i18next.t('有效票'), value: fmt.format(voting.validVotes) },
    { label: i18next.t('废票'), value: fmt.format(voting.rejectedVotes) },
  ];

  return (
    <div className="voting-summary">
      <div className="voting-summary__grid">
        {cells.map((c) => (
          <div key={c.label} className="voting-summary__cell">
            <div className="voting-summary__label">{c.label}</div>
            <div className="voting-summary__value">{c.value}</div>
          </div>
        ))}
        <div className="voting-summary__cell voting-summary__cell--turnout">
          <div className="voting-summary__label">{i18next.t('投票率')}</div>
          <div className="voting-summary__turnout">{turnoutDisplay}</div>
        </div>
      </div>
    </div>
  );
};

export default VotingSummary;
